export enum InputTypeEnum {
	Text,
	Number,
	Currency
}
